export var referenceToString = function (it) { return it.name; };
export var referenceToKey = function (it) { return it.code; };
export var lookupIdentifierToName = function (it) { return (it === null || it === void 0 ? void 0 : it.name) || ''; };
export var lookupIdentifierToKey = function (it) { return (it === null || it === void 0 ? void 0 : it.id) || 'keyMissing'; };
export var lookupIdentifierToAuthSystemKey = function (it) {
    if ((it === null || it === void 0 ? void 0 : it.authoringSystem) && (it === null || it === void 0 ? void 0 : it.authoringSystemForeignKey)) {
        return it.authoringSystem + it.authoringSystemForeignKey;
    }
    return 'keyMissing';
};
export var compareLookupIdentifiers = function (a, b) {
    return (a === null || a === void 0 ? void 0 : a.id) === (b === null || b === void 0 ? void 0 : b.id);
};
export var convertToLookUpIdentifier = function (it) {
    return {
        id: it.id,
        authoringSystem: it.authoringSystem,
        authoringSystemForeignKey: it.authoringSystemForeignKey
    };
};
export function isLookupIdentifier(thing) {
    return thing.name !== undefined;
}
export function joinLookupIdentifierNamesWithCommas(items) {
    return items.map(function (item) { return item.name; }).join(', ');
}
